"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("../../../Button/Button"));
var _Modal = _interopRequireDefault(require("../../../Modal"));
var _Toggle = _interopRequireDefault(require("../../../helpers/Toggle"));
var _constants = require("../../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Ratings = function Ratings() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component margin-top-xl"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-center d8-u-text-bold"
  }, "Available on:"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-btn--wrapper flex justify-center flex-column flex-row@xs"
  }, /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref) {
    var on = _ref.on,
      toggle = _ref.toggle;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      buttonType: _constants.BUTTON_TYPES.RATING_STANDARD,
      text: "Standard",
      onClick: toggle
    }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      on: on,
      toggle: toggle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center text-component"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      buttonType: _constants.BUTTON_TYPES.RATING_STANDARD,
      text: "Standard",
      onClick: toggle
    }), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "no-style margin-top-md"
    }, /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "10 people max. capacity"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "Monohulls only"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "From 2011 or newer"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "Minimum two bathrooms"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "Fully equipped kitchen"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "Great value experience")), /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-text-bold"
    }, "Ideal for first time yacht-weekers"))));
  }), /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref2) {
    var on = _ref2.on,
      toggle = _ref2.toggle;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      buttonType: _constants.BUTTON_TYPES.RATING_PREMIUM,
      text: "Premium",
      onClick: toggle
    }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      on: on,
      toggle: toggle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center text-component"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      buttonType: _constants.BUTTON_TYPES.RATING_PREMIUM,
      text: "Premium",
      onClick: toggle
    }), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "no-style margin-top-md"
    }, /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "12 people max. capacity"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "Catamarans and monohulls"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "6 years old or newer"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "Larger than a standard yacht"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "More spacious cabins and lounge area"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "Best sound system")), /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-text-bold"
    }, "Best for those wanting speed, comfort and an authentic sailing experience"))));
  }), /*#__PURE__*/_react["default"].createElement(_Toggle["default"], null, function (_ref3) {
    var on = _ref3.on,
      toggle = _ref3.toggle;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      buttonType: _constants.BUTTON_TYPES.RATING_PREMIUM_PLUS,
      text: "Premium",
      onClick: toggle,
      icon: "plus",
      iconFlip: true
    }), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
      on: on,
      toggle: toggle
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center text-component"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      buttonType: _constants.BUTTON_TYPES.RATING_PREMIUM_PLUS,
      text: "Premium",
      onClick: toggle,
      icon: "plus",
      iconFlip: true
    }), /*#__PURE__*/_react["default"].createElement("ul", {
      className: "no-style margin-top-md"
    }, /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "14 people max. capacity"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "Catamarans and monohulls"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "5 years old or newer"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "More kitchen and storage space"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "Best sound system"), /*#__PURE__*/_react["default"].createElement("li", {
      className: "d8-u-color-contrast-high"
    }, "Cool down with the AC system")), /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-text-bold"
    }, "Best for those after space and a more luxurious experience"))));
  })));
};
var _default = exports["default"] = Ratings;